module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "item-select",
    class: {
      disable: (_vm.item && _vm.item.nonEditable) || _vm.disabled
    }
  }, [(!_vm.form[_vm.item.attr].id) ? _c('el-input', {
    attrs: {
      "placeholder": '请点击“选择”添加',
      "readonly": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form && _vm.form[_vm.item.attr].value) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.form[_vm.item.attr].value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": _vm.del
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.attrValue) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.attrValue.value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": _vm.del
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleSelect
    }
  }, [_vm._v("选择")])], 1), _vm._v(" "), (_vm.showRemote) ? _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "remote-select"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "输入关键词进行搜索"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": _vm.handleSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "scroll-con"
  }, [_c('el-radio-group', {
    staticClass: "list-con",
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  }, _vm._l((_vm.listData), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "change": function($event) {
          _vm.saveObj(item)
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.value))])], 1)
  })), _vm._v(" "), (_vm.showNodata) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n        暂无数据\n      ")]) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd12942","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/remote-select.vue
// module id = 1227
// module chunks = 82